import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './TabBar.scss';
/**
 * @component TabBar
 * @since 1.0.0
 */
export const TabBar = React.forwardRef(function TabBar(props, ref) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('tab-bar', 'tab-bar--' + style, props.className);
    return (React.createElement("div", { ref: ref, className: className, role: "tablist", onKeyDown: props.onKeyDown }, props.children));
});
